export const normalizeTutorType = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  return raw === "coach" ? "Coach" : "Teacher";
};

export const isCoachType = (value) => normalizeTutorType(value) === "Coach";

export const getStoredTutorType = () => {
  if (typeof window === "undefined") return "Teacher";
  return normalizeTutorType(localStorage.getItem("activeTutorType"));
};

export const setStoredTutorType = (value) => {
  if (typeof window === "undefined") return;
  localStorage.setItem("activeTutorType", normalizeTutorType(value));
};

export const getRoleLabels = (t, tutorType) => {
  const coach = isCoachType(tutorType);
  return {
    isCoach: coach,
    tutorLabel: coach ? t("Coach") : t("Teacher"),
    learnerSingular: coach ? t("Client") : t("Student"),
    learnerPlural: coach ? t("Clients") : t("Students"),
    classSingular: coach ? t("Program") : t("Class"),
    classPlural: coach ? t("Programs") : t("Classes"),
    groupClassLabel: coach ? t("Group (program)") : t("Group (class)"),
    enrollmentsLabel: coach ? t("Programs") : t("Enrollments"),
  };
};
